import React from 'react';
import { useSelector } from 'react-redux';
import { App } from './components/App/App';
import email from './images/emails.png';
import audio from './images/audio.png';
import salesforce from './images/salesforce.png';
import { RootState } from '../../store/store';

type AppI = {
  title: string;
  body: string;
  preview: string;
  defaultActive: boolean;
  status: 'active' | 'inactive';
};

const APPS: AppI[] = [
  {
    title: 'Q beta for Email',
    body:
      'Analyze your business relationships, and learn how to maximize your advantage',
    preview: email,
    defaultActive: true,
    status: 'active',
  },
  {
    title: 'Q beta for Audio',
    body: '',
    preview: audio,
    defaultActive: false,
    status: 'inactive',
  },
  {
    title: 'SalesForce Integration',
    body: '',
    preview: salesforce,
    defaultActive: false,
    status: 'inactive',
  },
];

export const Apps: React.FC = (): JSX.Element => {
  const { user } = useSelector((state: RootState) => state.auth);

  const isActive = (index: number) =>
    typeof user?.apps[index] !== undefined
      ? user?.apps[index]?.active
      : APPS[index].defaultActive;

  return (
    <div className="apps">
      {APPS.map((app, index) => (
        <App
          role={user?.role}
          key={app.title}
          {...app}
          defaultActive={isActive(index)}
          name={user?.apps[index]?.name}
        />
      ))}
    </div>
  );
};
